// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__wOLm_","ellipsis":"styles_ellipsis__M9yyL","text2AndMoreLines":"styles_text2AndMoreLines__ulwJi","tooltipTrigger":"styles_tooltipTrigger__B_6sq"};